export default __webpack_public_path__ + "static/media/riposte.d8b4a3a5.png";